import { ComponentType } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { withRouter } from 'react-router';
import { withAppData } from 'client/contexts/app-data';
import { getAppMenu } from 'client/ducks/app/selectors';
import { getCurrentPathname } from 'client/ducks/router/selectors';
import { State } from 'client/store';

import SideNav, { StateProps, ComponentProps } from './side-nav';

function mapStateToProps(state: State): StateProps {
    return {
        links: getAppMenu(state),
        // Прокидывает pathname что-бы компонент обновлялся при смене страницы
        pathname: getCurrentPathname(state)
    };
}

export default compose<ComponentType<ComponentProps>>(
    connect<StateProps>(mapStateToProps),
    withRouter,
    withAppData
)(SideNav);
